/** Visible brand mark: "High Five Access™". The ™ inherits color, font and weight. */
export default function BrandName({ text = "High Five Access", className = "" }) {
  return (
    <span className={`whitespace-nowrap ${className}`.trim()} data-testid="brand-name">
      {text}
      <sup
        aria-label="trademark"
        className="font-sans"
        style={{
          fontSize: "0.7em",
          lineHeight: 1,
          verticalAlign: "baseline",
          position: "relative",
          top: "-0.45em",
          marginLeft: "0.08em",
          fontWeight: "inherit",
          color: "inherit",
          letterSpacing: 0,
        }}
      >
        ™
      </sup>
    </span>
  );
}
